import { Button, Stack } from "@mui/material";
import Image from "src/components/Image";
import LanguagePopover from "src/components/LanguagePopover/LanguagePopover";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

type Props = {
	hideLanguage?: boolean;
};

export const LogoHeader = ({ hideLanguage }: Props) => {
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	const onClick = () => {
		window.open(
			"https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0WJW-83c5kX9OJgD3DMXb7NQmXi0go-kf6PA4_JMq-Bl6SAtfbUZAKwO_1xeLVoz7Xa8EEeKp3",
			"_blank"
		);
	};

	return (
		<Stack
			flexDirection={"row"}
			alignItems={"center"}
			justifyContent={"space-between"}
			sx={{ px: 6, py: 5, width: "100%" }}
		>
			<Image src={`/logo/logo_iso.svg`} fit='cover' />
			<Stack flexDirection={"row"} alignItems={"center"} gap={3}>
				{!hideLanguage && <LanguagePopover />}
				<Button variant='contained' onClick={onClick} size={isMobile ? "small" : "medium"}>
					{isMobile ? translate("demo.contact") : translate("demo.contact_us")}
				</Button>
			</Stack>
		</Stack>
	);
};

export default LogoHeader;
